// extracted by css-extract-rspack-plugin
export default {"cls1":"NewsHeader-cls1_mHp","cls2":"NewsHeader-cls2_i5v NewsHeader-cls1_mHp"};